var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1111 0H0.888902C0.398013 0 0 0.397988 0 0.888878V10C0 10.4909 0.398013 10.8889 0.888902 10.8889H13.1111C13.602 10.8889 14 10.4909 14 9.99998V0.888878C14 0.397988 13.602 0 13.1111 0ZM13.1111 0.888878V7.35353L11.3593 5.76087C11.096 5.52154 10.6911 5.53109 10.4395 5.78288L8.66661 7.55553L5.17089 3.37998C4.90665 3.06442 4.42265 3.06132 4.15444 3.37309L0.888902 7.16821V0.888878H13.1111ZM9.33334 3.22221C9.33334 2.54709 9.8804 1.99998 10.5555 1.99998C11.2307 1.99998 11.7777 2.54709 11.7777 3.22221C11.7777 3.89733 11.2307 4.44442 10.5555 4.44442C9.88043 4.44444 9.33334 3.89733 9.33334 3.22221Z",
    className: "purple"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.5294862aade031ae4db05a3321cc4fc2.svg";
export { ForwardRef as ReactComponent };